import MapMixin from '@/Mixins/map';
export default {
  mixin: [MapMixin],
  data() {
    return {
      isFenceModalOpen: false,

      colorValue: '#1976D2FF',
      currentFenceColor: '#1976D2FF',
    };
  },
  methods: {
    openHospitalFenceModal: function (id) {
      this.hospitalId = id;
      this.isFenceModalOpen = true;
    },
    closeHospitalFenceModal: function () {
      this.fenceCoordinatesList = null;
      this.hospitalId = null;
      this.isFenceModalOpen = false;
    },
    setHospitalFence: function () {
      this.closeHospitalFenceModal();
    },
    enableFenceModal: function (hasFence) {
      this.fenceMapInvalidate();
      if (!hasFence) {
        this.$nextTick(() => {
          const map = this.$refs.fancemap.mapObject;
          map.pm.setLang('fa');
          map.on('pm:create', ({ layer }) => {
            this.drawFanse(layer);
          });
          map.pm.addControls({
            position: 'bottomleft',
            drawCircle: false,
            drawRectangle: false,
            drawPolyline: false,
            editMode: false,
            cutPolygon: false,
            drawCircleMarker: false,
            drawMarker: false,
            optionsControls: false,
            removalMode: false,
            dragMode: false,
            drawText: false,
            rotateMode: false,
            drawPolygon: true,
          });
        });
      } else {
        this.$nextTick(() => {
          const map = this.$refs.fancemap.mapObject;
          map.pm.setLang('fa');
          map.on('pm:remove', ({ layer }) => {
            this.removeFance(layer);
          });
          map.on('pm:globaleditmodetoggled', (e) => {
            e.map.pm.getGeomanLayers(true).on('pm:update', ({ layer }) => {
              this.editFance(layer);
            });
          });
          map.pm.addControls({
            position: 'bottomleft',
            drawCircle: false,
            drawRectangle: false,
            drawPolyline: false,
            editMode: true,
            cutPolygon: false,
            drawCircleMarker: false,
            drawMarker: false,
            optionsControls: false,
            removalMode: true,
            dragMode: false,
            drawText: false,
            rotateMode: false,
            drawPolygon: false,
          });
        });
      }
    },
    drawFanse: function (layer) {
      this.drawLayer = layer;
      var coords = layer.getLatLngs();
      this.fenceCoordinatesList = coords[0];
      this.$nextTick(() => {
        const map = this.$refs.fancemap.mapObject;
        map.pm.setLang('fa');
        map.on('pm:remove', ({ layer }) => {
          this.removeFance(layer);
        });
        map.on('pm:globaleditmodetoggled', (e) => {
          e.map.pm.getGeomanLayers(true).on('pm:update', ({ layer }) => {
            this.editFance(layer);
          });
        });
        map.pm.addControls({
          position: 'bottomleft',
          drawCircle: false,
          drawRectangle: false,
          drawPolyline: false,
          editMode: true,
          cutPolygon: false,
          drawCircleMarker: false,
          drawMarker: false,
          optionsControls: false,
          removalMode: true,
          dragMode: false,
          drawText: false,
          rotateMode: false,
          drawPolygon: false,
        });
      });
    },
    removeFance: function (layer) {
      this.drawLayer = layer;
      this.fenceCoordinatesList = [];
      this.$nextTick(() => {
        const map = this.$refs.fancemap.mapObject;
        map.pm.setLang('fa');
        map.on('pm:create', ({ layer }) => {
          this.drawFanse(layer);
        });
        map.pm.addControls({
          position: 'bottomleft',
          drawCircle: false,
          drawRectangle: false,
          drawPolyline: false,
          editMode: false,
          cutPolygon: false,
          drawCircleMarker: false,
          drawMarker: false,
          optionsControls: false,
          removalMode: false,
          dragMode: false,
          drawText: false,
          rotateMode: false,
          drawPolygon: true,
        });
      });
    },
    editFance: function (layer) {
      this.drawLayer = layer;
      const coords = layer.getLatLngs();
      this.fenceCoordinatesList = coords[0];
      this.$nextTick(() => {
        const map = this.$refs.fancemap.mapObject;
        map.pm.setLang('fa');
        map.on('pm:remove', ({ layer }) => {
          this.removeFance(layer);
        });
        map.on('pm:globaleditmodetoggled', (e) => {
          e.map.pm.getGeomanLayers(true).on('pm:update', ({ layer }) => {
            this.editFance(layer);
          });
        });
        map.pm.addControls({
          position: 'bottomleft',
          drawCircle: false,
          drawRectangle: false,
          drawPolyline: false,
          editMode: true,
          cutPolygon: false,
          drawCircleMarker: false,
          drawMarker: false,
          optionsControls: false,
          removalMode: true,
          dragMode: false,
          drawText: false,
          rotateMode: false,
          drawPolygon: false,
        });
      });
    },
  },
  watch: {
    isFenceModalOpen: function (currentValue) {
      if (currentValue) {
        // this.enableFenceModal();'

        this.fenceCoordinatesList = null;
        this.getHospitalFencesList(this.hospitalId);
      }
    },
    polygonData: {
      handler: function (currentVal) {
        const hasFence = !!currentVal?.length && this.isFenceModalOpen;
        this.enableFenceModal(hasFence);
        if (hasFence) {
          this.fenceCentering(currentVal);
        }
      },
      immediate: true,
    },
  },
};
